import React from 'react';
import Helmet from 'react-helmet';
import PageLayout from '../components/PageLayout';
import styles from './highlights.module.scss';
import { Talk } from '../components';

const Highlights = ({location}) => (
  <PageLayout location={location}>
    <Helmet>
      <title>Marxism Highlights</title>
      <meta property="og:title" content="Marxism Highlights" />
    </Helmet>
      <div className={styles.content}>
        <h1 className={styles.header}>Audio highlights from previous Marxism conferences</h1>
        <Talk
          title='#blacklivesmatter and police racism'
          speaker='Khury Peterson-Smith'
          mp3_url='https://talks.marxismconference.org/Marxism2015/BlackLivesMatter and police racism.mp3'
        />
        <Talk
          title='Doesn’t Marxism work in theory but not in practise?'
          speaker='Declan Murphy'
          mp3_url='https://talks.marxismconference.org/Marxism2017/Doesnt Marxism work in theory but not in practice.mp3'
        />
        <Talk
          title='Festival of the oppressed: a celebration of 1917'
          speaker='Sandra Bloodworth '
          mp3_url='https://talks.marxismconference.org/Marxism2017/Festival of the oppressed - A celebration of 1917.mp3'
        />
        <Talk
          title='Green capitalism: the god that failed '
          speaker='Michael Kandelaars'
          mp3_url='https://talks.marxismconference.org/Marxism2017/Green capitalism - The god that failed.mp3'
        />
        <Talk
          title='The modern working class'
          speaker='Kath Larkin'
          mp3_url='https://talks.marxismconference.org/Marxism2015/The modern working class.mp3'
        />
        <Talk
          title='The politics of politeness'
          speaker='Steph Price'
          mp3_url='https://talks.marxismconference.org/Marxism2015/The politics of politeness.mp3'
        />
        <Talk
          title='Populism and the rise of the political outsider '
          speaker='Rick Kuhn'
          mp3_url='https://talks.marxismconference.org/Marxism2017/Populism and the rise of the political outsider.mp3'
        />
        <Talk
          title='Whiteness theory: a Marxist critique'
          speaker='Vinil Kumar'
          mp3_url='https://talks.marxismconference.org/Marxism2017/Whiteness theory a marxist critique.mp3'
        />
        <Talk
          title='Marxism 101: Gender and Sexuality'
          speaker='Tess Dimos'
          mp3_url='https://talks.marxismconference.org/Marxism2017/dimos_m17_gender.mp3'
        />
        <Talk
          title='A revolutionary primer to Russia 1917'
          speaker='Daniel Taylor'
          mp3_url='https://talks.marxismconference.org/Marxism2017/taylor_m17_russia.mp3'
        />
        <Talk
          title='Red Petrograd in 1917 How the Bolsheviks Led the Revolution'
          speaker='Colleen Bolger'
          mp3_url='https://talks.marxismconference.org/Marxism2010/34 Red Petrograd in 1917_ How the Bolsheviks Led the Revolut.mp3'
        />
        <Talk
          title='Class structure and agency: the Australian working class in the 21st century'
          speaker='Tom Bramble'
          mp3_url='https://talks.marxismconference.org/Marxism2011/Class Structure and Agency The Australian Working Class in the 21st Century - Marxism 2011.mp3'
        />
        <Talk
          title='Did Lenin lead to Stalin?'
          speaker='Kostas Rologas'
          mp3_url='https://talks.marxismconference.org/Marxism2012/Did Lenin lead to Stalin - Marxism 2012.mp3'
        />
        <Talk
          title='Key Texts of Marxism The Communist Manifesto '
          speaker='Michael Kandelaars'
          mp3_url='https://talks.marxismconference.org/Marxism2011/Key Texts of Marxism The Communist Manifesto - Marxism 2011.mp3'
        />
        <Talk
          title='Class or sect - Politics in the modern Middle East'
          speaker='Omar Hassan'
          mp3_url='https://talks.marxismconference.org/Marxism2017/Class or sect - Politics in the modern middle east.mp3'
        />
        <Talk
          title='While down the craters the morning burns - WWI anti-war poets '
          speaker='Dougal McNeill'
          mp3_url='https://talks.marxismconference.org/Marxism2015/While down the craters the morning burns - WWI anti-war poets.mp3'
        />
        <Talk
          title='Islamophobia and the fallacy of progressive secularism '
          speaker='Mick Armstrong'
          mp3_url='https://talks.marxismconference.org/Marxism2015/Islamophobia and the fallacy of progressive secularism.mp3'
        />
        <Talk
          title='Free Derry - the struggle for civil rights in Ireland in the 1960s and 1970s '
          speaker='Eamonn Mccann'
          mp3_url='https://talks.marxismconference.org/Marxism2015/Free Derry - the struggle for civil rights in Ireland in the 1960s and 1970s.mp3'
        />
        <Talk
          title='Three Union Revivals'
          speaker='Jerome Small'
          mp3_url='https://talks.marxismconference.org/Union2014/Jerome Small - Three union revivals.mp3'
        />
        <Talk
          title='Early Japanese women communists'
          speaker='Shomi Yoon'
          mp3_url='https://talks.marxismconference.org/Marxism2014/08 Early Japanese women communists - Marxism 2014.mp3'
        />
        <Talk
          title='Rank and file rebellion in the Pilbara - the Robe River dispute'
          speaker='Graeme Haynes & Liz Ross'
          mp3_url='https://talks.marxismconference.org/Union2014/Graeme Haynes Liz Ross - Robe River 1986.mp3'
        />


      </div>
  </PageLayout>
);

export default Highlights;
